
<script type="text/javascript">
import ListComponent from './list';
import TitleComponent from './title';
import InputComponent from './input';

export default {
  props: {
    props: {
      type: Object,
      default () {
        return {
          value: 'value',
          label: 'label',
          children: 'children'
        };
      }
    },
    options: Array,
    value: Array,
    popoverVisible: Boolean,
    titles: Array,
    placeholder: String,
    separator: {
      type: String,
      default: '/'
    },
    size: String,
    changeOnSelect: Boolean,
    name: String,
    responsive: {
      type: Boolean,
      default: true
    },
    appendToBody: {
      type: Boolean,
      default: false
    },
    autoClose: {
      type: Boolean,
      default: true
    },
    canCancel: Boolean,
    labelFormatter: Function,
    noListMsg: String
  },
  watch: {
    options: {
      deep: true,
      handler (v) {
        this.watcherHandler(v);
        if (this.selecteds.length) {
          this.mapSelectedLists();
        }
      }
    },

    popoverVisible (v) {
      if (!v) {
        this.cascader.componentInstance.close();
        return;
      }
      this.cascader.componentInstance.show();
    },

    value (val) {
      if (this.selecteds) {
        this.mapSelectedLists();
      }
    }
  },
  data () {
    return {
      lists: [],
      currentLevel: 0,
      complated: false,
      tempSelecteds: [],
      selectedLables: ''
    };
  },
  computed: {
    selecteds: {
      get () {
        return this.value || [];
      },
      set (v) {
        this.$emit('input', v);
      }
    },
    titleMode () {
      return !!this.titles;
    }
  },
  methods: {
    watcherHandler (v) {
      this.lists = [v];
      // 支持异步加载数据
      const lastSelect = this.tempSelecteds[this.tempSelecteds.length - 1];
      if (!lastSelect || !this.lastLevel) {
        return;
      }
      const children = lastSelect[this.props.children];
      this.$set(this.lists, this.lastLevel, children);
    },
    reset () {
      this.selecteds = [];
      this.tempSelecteds = [];
      this.switchLevel(0);
      this.lastLevel = 0;
    },
    switchLevel (i) {
      this.currentLevel = i;
    },
    listChange (item, level) {
      let children = null;
      // 有item是选中，没有是取消选中
      if (item) {
        children = item[this.props.children];
        this.tempSelecteds[level] = item;
        this.tempSelecteds = this.tempSelecteds.slice(0, level + 1);
      } else {
        // 走取消逻辑
        this.tempSelecteds = this.tempSelecteds.slice(0, level);
      }
      const nextLevel = level + 1;

      this.$emit('change', this.tempSelecteds);

      if (children) {
        this.lastLevel = nextLevel;
        this.lists = this.lists.slice(0, level + 1);
        this.$set(this.lists, nextLevel, children);

        if (this.titleMode) {
          this.$nextTick(() => {
            this.switchLevel(nextLevel);
          });
        }
        // this.$emit('activeItemChange', children);
      } else {
        this.$delete(this.lists, nextLevel);
        if (this.autoClose) {
          this.cascader.componentInstance.close();
        }

        if (!this.changeOnSelect) {
          this.selecteds = JSON.parse(JSON.stringify(this.tempSelecteds.map(item => item[this.props.value])));
          this.selectedLables = this.getLabels();
        }
        this.$emit('complated');
      }

      if (this.changeOnSelect) {
        this.selecteds = JSON.parse(JSON.stringify(this.tempSelecteds.map(item => item[this.props.value])));
        this.selectedLables = this.getLabels();
      }
    },
    getLabels () {
      return this.tempSelecteds.map(item => {
        if (this.labelFormatter) {
          return this.labelFormatter(item);
        }
        return item[this.props.label];
      }).join(this.separator);
    },
    mapSelectedLists () {
      let list = this.options;
      const selecteds = this.tempSelecteds.length ? this.tempSelecteds.map(item => item[this.props.value]) : this.selecteds;
      this.tempSelecteds = selecteds.map((selectedValue, i) => {
        if (!list) {
          return;
        }
        const current = list.find(listItem => listItem[this.props.value] === selectedValue) || list[0];
        this.$set(this.lists, i, list);
        list = current[this.props.children];
        return current;
      });
      this.selectedLables = this.getLabels();
    }
  },
  mounted () {
    if (this.options.length) {
      this.watcherHandler(this.options);
      if (this.selecteds) {
        this.mapSelectedLists();
      }
    }
  },
  render (h) {
    const cols = this.lists.map((list = [], i) => {
      const cp = h(ListComponent, {
        props: {
          list,
          props: this.props,
          value: this.tempSelecteds[i],
          canCancel: this.canCancel,
          noListMsg: this.noListMsg
        },
        on: {
          change: item => {
            this.listChange(item, i);
          }
        }
      }, [this.$scopedSlots.item]);
      if (!this.titleMode) {
        return cp;
      }

      // titleMode 模式只返回当前list;
      if (this.currentLevel === i) {
        return cp;
      }
    });

    const t = h(TitleComponent, {
      props: {
        titles: this.titles,
        lists: this.lists,
        current: this.currentLevel
      },
      on: {
        switch: this.switchLevel
      }
    });

    this.cascader = h(InputComponent, {
      props: {
        // selects: this.tempSelecteds.map(item => item[this.props.label]).join(this.separator),
        selects: this.selectedLables,
        placeholder: this.placeholder,
        visible: this.visible,
        name: this.name,
        size: this.size,
        responsive: this.responsive,
        appendToBody: this.appendToBody
      },
      on: {
        reset: this.reset,
        visbileChange: (v) => {
          this.$emit('update:popoverVisible', v);
        }
      },
      scopedSlots: {
        label: this.$scopedSlots.label ? this.$scopedSlots.label : null
      },
      class: {
        'is-title-mode': this.titleMode
      }
    }, [this.$slots.header, t].concat(cols));

    return this.cascader;
  }
};
</script>



// WEBPACK FOOTER //
// src/components/cascader/index.vue